import { render } from "./AddEditLabels.vue?vue&type=template&id=dbef9596"
import script from "./AddEditLabels.vue?vue&type=script&lang=js"
export * from "./AddEditLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__